window.addEventListener("load", function () {

    if(this.window.innerWidth >= 768) {
        let scroll = this.document.querySelector('#js-on-scroll-padding');
        this.window.addEventListener('scroll', function(e) {
            if(this.window.scrollY > 80) {
                scroll?.classList.add('upsd-header__top_light');
            } else {
                scroll?.classList.remove('upsd-header__top_light');
            }
        });
    }

});